import React from "react";

const contactIntro =
  "If you are unable to delete your account, you can reach out to us by contacting: ";

const contactEmail = "inquire@hindusrus.org";
const emailTo = `mailto:${contactEmail}`;

const openEmail = (event) => {
  event.preventDefault();

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    window.location.href = emailTo;
  } else {
    window.open(
      `https://mail.google.com/mail/?view=cm&fs=1&to=${contactEmail}`,
      "_blank",
      "noopener,noreferrer"
    );
  }
};

const deleteAccountInstructionConfig = {
  pageTitle: "Delete Account",
  sections: [
    {
      id: "overview",
      title: "Instructions",
      paragraphs: [
        "If you would like to delete your account, you can do so directly within the app.",
      ],
    },
    {
      id: "steps",
      title: "Steps:",
      orderedList: [
        "Open the app",
        "Go to Profile",
        "Edit Profile",
        'Tap "Delete Account"',
      ],
    },
    {
      id: "what-happens",
      title: "What happens when you delete your account:",
      unorderedList: [
        "Your account is permanently deleted from our Database",
        "All associated personal data is removed",
        "This action cannot be undone",
      ],
    },
    {
      id: "help",
      title: "Need help?",
      paragraphs: [
        React.createElement(
          React.Fragment,
          null,
          contactIntro,
          React.createElement(
            "a",
            {
              href: emailTo,
              className: "delete-account-email",
              onClick: openEmail,
            },
            contactEmail
          )
        ),
      ],
    },
  ],
};

export default deleteAccountInstructionConfig;